module.exports = __webpack_public_path__ + "7aac94a7359d470393b8287d3d2959e7.svg";